import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const TutorialWrapper = styled(Box)`
  img {
    max-width: 100%;
  }
`
